import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
@Injectable({
    providedIn: 'root'
})
export class BuyerOrderHistoryService {

    constructor(private _http: HttpClient) { }

    buyerorders(data) {
        return this._http.post(environment.api_url + 'buyer/orders', data);
    }

}